import React from 'react'
import { useState } from 'react';
import { Table, Row, Col } from 'antd'
import { Map, APILoader, Provider, useMapContext } from '@uiw/react-baidu-map';
import {cordConvert} from '../../utils'
import { useEffect } from 'react';

const columns = [
    {
      title: '日期',
      dataIndex: 'startTime',
      key: 'startTime',
      width: '20%', 
      align: 'center',  
    },
    {
      title: '活动',
      dataIndex: 'event',
      key: 'event',
      align: 'left',
    },
]

const BaiduMap = (props)=> {
    const { map, BMap } = useMapContext();
    const {event} = props
    useEffect(() => {
        if (event && map) {
            map.clearOverlays()
            var point = new BMap.Point(event.lon, event.lat);
            const marker = new BMap.Marker(point);
            const opts = {
                position : point,    // 指定文本标注所在的地理位置
                offset   : new BMap.Size(10, -10)    //设置文本偏移量
              }
            const label = new BMap.Label(cordConvert(event.lat, event.lon), opts); 
            map.addOverlay(marker)
            map.addOverlay(label)
        }
    }, [event])
    if (event){
        const pos = {lng: event.lon, lat: event.lat}
        return (
            <Map center={pos} zoom={1}>
            </Map>
        )
    }else{
        return (
            <Map zoom={1}></Map>
        )
    }    
}

const ShipActivities = (props) => {
    const {events} = props
    const [selectedEvent, setSelectedEvent] = useState(null)
    if (events.length>0){
        return (
            <Row align='middle' justify='center'>
                <Col span={14}>
                    <Table columns={columns} bordered={true} showHeader={true} dataSource={events} size="small" 
                        pagination={{hideOnSinglePage:true, pageSize:12}} style={{cursor: 'pointer'}}
                        onRow={(record) => {
                            return {
                            onMouseEnter: (e) => {
                                setSelectedEvent(record)
                            },
                            // onMouseLeave: (e) => {
                            //     setSelectedEvent({})
                            // },
                        }}}></Table>
                </Col> 
                <Col span={9} offset={1}>
                    <div style={{ width: '25vw', height: '50vh'}}>
                        <APILoader akay="PBY8a0Srye77leaBnETSUiuGGmARNiTj">
                            <Provider>
                                <BaiduMap event={selectedEvent}/>
                            </Provider>
                        </APILoader>
                    </div>
                   
                </Col>
            </Row>
        )
        
    }else{
        return <p>数据查询中……</p>
    }
}

export default ShipActivities